import moment from 'utils/cops-moment';
import { blockConfig } from '../config';

const mapBlock = (block, showTravelTime) => {
  const labour = block.subBlocks?.find(sb => sb.activityType === blockConfig.activityTypes.labour);
  const isNotFieldService =
    block.type === 'absence' || block.type === 'reservation' || block.type === 'placeholder';

  const startMoment = showTravelTime || isNotFieldService ?
    moment(block.start) :
    moment(labour?.start);

  const durationInMinutes = showTravelTime || isNotFieldService ?
    moment.duration(block.duration).asMinutes() :
    moment.duration(labour?.duration).asMinutes();
  const travelTo =
    block.subBlocks?.find(sb => sb.activityType === blockConfig.activityTypes.travelTo);
  const travelFrom =
    block.subBlocks?.find(sb => sb.activityType === blockConfig.activityTypes.travelFrom);

  // Calculate labour and whole block duration, used to set the endMoment
  // according to whether the travel time should be taken into account
  const durationLabourInMinutes = moment.duration(labour?.duration).asMinutes();

  // Setting durations to 0, conditionally, if the travel should be hidden
  const durationTravelToInMinutes =
    travelTo && showTravelTime ? moment.duration(travelTo.duration).asMinutes() : 0;
  const durationTravelFromInMinutes =
    travelFrom && showTravelTime ? moment.duration(travelFrom.duration).asMinutes() : 0;
  const endMoment = showTravelTime || isNotFieldService ?
    startMoment.clone().add(durationInMinutes, 'minutes') :
    startMoment.clone().add(durationLabourInMinutes, 'minutes');

  return {
    id: block.id,
    laneId: block.laneId,
    actions: block.actions,
    uri: block.uri,
    start: block.start,
    duration: block.duration,
    end: block.end,
    objectId: block.objectId,
    type: block.type,
    title: block.title,
    icon: block.icon,
    line1: block.line1,
    line2: block.line2,
    line3: block.line3,
    canMove: block.canMove,
    isDraft: block.isDraft,
    showAs: block.showAs,
    subBlocks: block.subBlocks,
    constraints: block.constraints,
    isDeleted: block.showAs === 'hidden' || block.isDeleted,
    isPreview: block.isPreview,
    outOfScope: block.outOfScope,
    serviceCenterId: block.serviceCenterId,
    durationDisplayUnit: block.durationDisplayUnit,
    alert: {
      ...block.alert,
      level: block.alert?.level?.toLowerCase(),
    },
    tags: block.tags,
    badges: block.badges,
    line: 1,
    startMoment,
    durationInMinutes,
    durationTravelToInMinutes,
    durationTravelFromInMinutes,
    durationLabourInMinutes,
    endMoment,
    draftSince: block.draftSince,
    references: block.references,
    lock: block.lock,
    operationInfo: block.operationInfo,
    isAssignedPlanner: block.isAssignedPlanner,
    assignedPlannerName: block.assignedPlannerName,
    isUserAdminForScope: block.isUserAdminForScope,
    requestedBy: block?.requestedBy,
    requestedOn: block?.requestedOn,
    lastUpdated: block?.lastUpdated,
  };
};

export default mapBlock;
